function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
  attributeType: "xml",
  attributeName: "transform",
  type: "rotate",
  from: "360 10 10",
  to: "0 10 10",
  dur: "1s",
  additive: "sum",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 10,
  r: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "m10,1C6.47,1,3.42,3.04,1.94,6.01c.02,0,.04,0,.06,0,.71,0,1.36.2,1.93.52,1.21-2.1,3.47-3.52,6.07-3.52,3.87,0,7,3.13,7,7s-3.13,7-7,7c-2.6,0-4.86-1.42-6.07-3.52-.58.32-1.23.52-1.93.52-.02,0-.04,0-.06,0,1.47,2.96,4.52,5.01,8.06,5.01,4.97,0,9-4.03,9-9S14.97,1,10,1Z"
}));

var SvgLoading = function SvgLoading(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading.25dc9998.svg";
export { ForwardRef as ReactComponent };